import { useCallback, useEffect, useState } from "react";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled";
import axios from "../../../axios";
import * as S from "../Funnel/Funnel.styled";

// Розсилки через шкільного Telegram-бота (@speaksy_en_bot). Зручно з телефона: шаблон → правка → «собі» → усім.
const when = (d) => (d ? new Date(d).toLocaleString("uk-UA", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

function Broadcasts() {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [text, setText] = useState("");
  const [segment, setSegment] = useState("all");
  const [promo, setPromo] = useState(true);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState("");

  const load = useCallback(() => {
    axios.get("admin/bot").then((r) => setInfo(r.data)).catch(() => setError("Не вдалося завантажити дані бота"));
  }, []);
  useEffect(() => { load(); }, [load]);

  const linkMyTelegram = async () => {
    const { data } = await axios.post("admin/bot/link", { kind: "admin" });
    window.open(data.url, "_blank", "noopener");
  };
  const applyTemplate = (t) => { setText(t.text); setPromo(t.promo); setResult(""); };
  const send = async (test) => {
    if (!text.trim()) return setResult("Напишіть повідомлення");
    const count = info?.segments?.[segment]?.chats ?? 0;
    if (!test && !window.confirm(`Надіслати повідомлення ${count} отримувачам («${info.segments[segment].label}»)?`)) return;
    setBusy(true); setResult("");
    try {
      const { data } = await axios.post("admin/bot/broadcast", { segment, text, promo, test });
      setResult(test ? "✅ Надіслано вам у Telegram — перевірте, як виглядає." : `✅ Доставлено ${data.delivered} з ${data.total}${data.blocked ? ` · заблокували бота: ${data.blocked}` : ""}${data.failed ? ` · помилок: ${data.failed}` : ""}`);
      load();
    } catch (e) {
      setResult("⚠️ " + (e?.response?.data?.message || "Не вдалося надіслати"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <PagesWrapper>
      <TopPageTitle value={"Розсилки"} />
      <S.Page>
        {error && <S.ErrorText>{error}</S.ErrorText>}
        {info && !info.enabled && <S.Card><S.Empty>Бот ще не підключений на сервері.</S.Empty></S.Card>}
        {info?.enabled && (
          <>
            <S.Card>
              <S.CardHead>
                <div>
                  <S.H>Telegram-бот @{info.username}</S.H>
                  <S.Hint>Учнів у боті: <b>{info.linkedStudents}</b> · пробних отримали доступ через бот: <b>{info.trialsDelivered}</b></S.Hint>
                </div>
                {!info.adminLinked
                  ? <S.Btn onClick={linkMyTelegram}>Підключити свій Telegram для перевірки</S.Btn>
                  : <S.Tag $c="green">ваш Telegram підключено</S.Tag>}
              </S.CardHead>

              <S.Small style={{ fontWeight: 700, marginBottom: 6 }}>Готові шаблони (можна редагувати)</S.Small>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
                {info.templates.map((t) => <S.Btn key={t.id} $ghost onClick={() => applyTemplate(t)}>{t.title}</S.Btn>)}
              </div>

              <textarea
                value={text}
                onChange={(e) => { setText(e.target.value); setResult(""); }}
                placeholder="Текст повідомлення. Жирний: <b>текст</b>"
                rows={7}
                style={{ width: "100%", boxSizing: "border-box", font: "inherit", padding: 12, borderRadius: 10, border: "1px solid #dcd7ee", resize: "vertical" }}
              />
              <S.Hint style={{ textAlign: "right", marginTop: 4 }}>{text.length} / 3500</S.Hint>

              <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center", margin: "10px 0" }}>
                <label style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: "0.85rem", fontWeight: 700 }}>
                  Кому
                  <S.Select value={segment} onChange={(e) => setSegment(e.target.value)}>
                    {Object.entries(info.segments).map(([k, v]) => <option key={k} value={k}>{v.label} — {v.chats}</option>)}
                  </S.Select>
                </label>
                <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: "0.9rem", cursor: "pointer" }}>
                  <input type="checkbox" checked={promo} onChange={(e) => setPromo(e.target.checked)} style={{ width: 18, height: 18, appearance: "auto", WebkitAppearance: "checkbox", opacity: 1, position: "static", accentColor: "#6c5ce7", flex: "none" }} />
                  Це акція (не надсилати тим, хто вимкнув акції)
                </label>
              </div>

              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <S.Btn $ghost disabled={busy || !info.adminLinked} onClick={() => send(true)}>Надіслати собі на перевірку</S.Btn>
                <S.Btn disabled={busy} onClick={() => send(false)}>{busy ? "Надсилаю…" : `Надіслати (${info.segments[segment]?.chats ?? 0})`}</S.Btn>
              </div>
              {result && <S.Hint style={{ marginTop: 10, fontWeight: 700 }}>{result}</S.Hint>}
              {!info.adminLinked && <S.Hint style={{ marginTop: 6 }}>Щоб надсилати собі на перевірку, спершу підключіть свій Telegram кнопкою вгорі.</S.Hint>}
            </S.Card>

            <S.Card>
              <S.CardHead><S.H>Історія розсилок</S.H></S.CardHead>
              {info.history.length === 0 ? <S.Empty>Ще не було розсилок</S.Empty> : (
                <S.List>
                  {info.history.map((h) => (
                    <li key={h._id}>
                      <span>{when(h.createdAt)} · <b>{h.test ? "перевірка" : info.segments[h.segment]?.label || h.segment}</b>
                        <S.Hint style={{ margin: 0 }}>{String(h.text).replace(/<[^>]+>/g, "").slice(0, 90)}{h.text.length > 90 ? "…" : ""}</S.Hint>
                      </span>
                      <S.Tag $c={h.failed || h.blocked ? "amber" : "green"}>{h.delivered}/{h.total}</S.Tag>
                    </li>
                  ))}
                </S.List>
              )}
            </S.Card>
          </>
        )}
      </S.Page>
    </PagesWrapper>
  );
}

export default Broadcasts;
